export enum Padding {
  none = "p-0",
  small = "p-md-2 p-sm-0 p-0",
  medium = "p-md-5 p-sm-1 p-2",
  large = "p-md-10 p-sm-4 p-4"
}



// WEBPACK FOOTER //
// ./src/lib/styles/Padding.tsx